define([
    'text!product-detail/page/ymb-page-content.html',
    'product-detail/grocery/knowledge-info',
    'product-detail/component/more-products',
    'product-detail/component/sku-info',
    'product-detail/component/spec-info',
    'product-detail/component/feature-list',
    'product-detail/ymb/ymb-legs',
    'product-detail/grocery/brand-info'
], function(
    tpl,
    KnowledgeInfo,
    MoreProducts,
    SkuInfo,
    SpecInfo,
    FeatureList,
    YmbLegs,
    BrandInfo
){
    return {
        template: tpl,
        components: {
            KnowledgeInfo: KnowledgeInfo,
            MoreProducts: MoreProducts,
            SkuInfo: SkuInfo,
            SpecInfo: SpecInfo,
            FeatureList: FeatureList,
            YmbLegs: YmbLegs,
            BrandInfo: BrandInfo
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/page/ymb-page-content.js
// module id = 276
// module chunks = 0